module.exports = __webpack_public_path__ + "static/img/15.1553e35a.png";